import {
  SET_MEMBERS
} from 'app/actions/types';

import {
  getMembers as getMembersSvc
} from 'app/services/members';

export const getMembers = params => async dispatch => {
  let members = await getMembersSvc(params);

  if (members) {
    dispatch({
      type: SET_MEMBERS,
      payload: members.params
    });
  }

  return members;
}

export const setMemberParams = params => async dispatch => {
  dispatch({
    type: SET_MEMBERS,
    payload: params
  });
}
